import React, { useEffect } from "react";
import { Table, Button } from "antd";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import { getAllLeaveAction } from "../../../../store/action/admin/allLeaveActions";
import ArrowRightIcon from "../../../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import CustomLoaderIcon from "../../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon.js";

const PeopleOnLeave = () => {
  const dispatch = useDispatch();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const themeDefault = useSelector((state) => state.themeDefault);
  const primaryColor = themeDefault?.info?.colorPrimary;
  const isDefaultTheme = themeDefault?.info?.themeColor === "default";
  const { loading = false, notifications = [] } = useSelector(
    (state) => state.allLeaves || {}
  );

  useEffect(() => {
    dispatch(getAllLeaveAction());
  }, [dispatch]);

  // Function to format date as DD (Mon) YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const leaveColumns = [
    { title: "ID", dataIndex: "id", key: "id", width: "5%", align: "center" },
    {
      title: "EMPLOYEE NAME",
      dataIndex: "employeeName",
      key: "employeeName",
      width: "50%",
      align: "left",
    },
    {
      title: "CATEGORY",
      dataIndex: "category",
      key: "category",
      width: "20%",
      align: "center",
    },
    {
      title: "PERIOD",
      dataIndex: "period",
      key: "period",
      width: "25%",
      align: "center",
    },
    {
      title: "DAYS TOTAL",
      dataIndex: "daysTotal",
      key: "daysTotal",
      width: "5%",
      align: "center",
    },
  ];

  const transformedData =
    notifications?.map((leave) => ({
      key: leave._id,
      id: leave.userId.empId,
      employeeName: `${leave.userId.name.firstName} ${leave.userId.name.lastName}`,
      category: leave.leaveType,
      period: `${formatDate(leave.startTime)} - ${formatDate(leave.endTime)}`,
      daysTotal: leave.leaveDays,
    })) || [];

  return (
    <div
      className={css`
        position: relative;
        min-height: 250px;
        height: 100%;
        display: flex;
        flex-direction: column;
      `}
    >
      {loading ? (
        <div
          className={css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: 250px;
            width: 100%;
          `}
        >
          <CustomLoaderIcon size="medium" color="black" />
        </div>
      ) : (
        <>
          <Table
            size="small"
            loading={loading}
            dataSource={transformedData.slice(0, 5)} // Show max 5 rows
            columns={leaveColumns}
            pagination={false}
            className={css`
              .ant-table-thead > tr > th {
                white-space: nowrap;
                text-align: center;
                background-color: transparent;
                height: 32px;
                color: ${isDefaultTheme ? "#230D39" : "white"};
                font-weight: 700 !important;
              }
              .ant-table-tbody > tr > td {
                background-color: transparent;
                text-align: center;
                height: 44px;
                color: ${isDefaultTheme ? "#230D39" : "white"};
              }
              .ant-table-tbody > tr > td:nth-child(2) {
                text-align: left;
              }
              .ant-table {
                background-color: transparent;
              }
              flex: 1;
            `}
          />

          {!loading && transformedData.length > 0 && (
            <div
              className={css`
                display: flex;
                justify-content: center;
                width: 100%;
                margin-top: auto;
                padding-top: 16px;
              `}
            >
              <Button
                type="link"
                style={{
                  color: primaryColor,
                  border: "none",
                  boxShadow: "none",
                }}
                onClick={() => {
                  window.location.href = `${process.env.REACT_APP_FE_HR_URL}/${
                    userType === "admin" ? userType : "manager"
                  }/time/leave-request/`;
                }}
              >
                View all <ArrowRightIcon size={16} />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PeopleOnLeave;
